import React from 'react';
import { Button, Dialog, DialogTitle, MenuItem } from '@mui/material';
import { DateTimeInput, SimpleForm, Toolbar, useRecordContext } from 'react-admin';
import useDialog from 'hooks/useDialog';
import { PhoneScreenScheduledStatus } from '../ApplicationStatusControl';
import AdministratorInput from 'components/Filter/AdministratorInput';
import { ENUMS } from 'components/Enum/enums';
import { useFormContext } from 'react-hook-form';

type PhoneScreenScheduledItemProps = {
  updateApplicationStatus: (val: any) => void;
};

const PhoneScreenScheduledItem = ({ updateApplicationStatus }: PhoneScreenScheduledItemProps) => {
  const { open, closeDialog, openDialog } = useDialog();

  return (
    <>
      <MenuItem onClick={openDialog}>Move to Phone Screen Scheduled (Manual)</MenuItem>
      <SchedulePhoneScreenDialog
        open={open}
        closeDialog={closeDialog}
        updateApplicationStatus={updateApplicationStatus}
      />
    </>
  );
};

const SchedulePhoneScreenToolBar = ({ closeDialog }) => {
  const { getValues } = useFormContext();
  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button onClick={closeDialog}>Cancel</Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={!getValues().screener_account_id || !getValues().scheduled_time}
      >
        Submit
      </Button>
    </Toolbar>
  );
};

const SchedulePhoneScreenDialog = ({ open, closeDialog, updateApplicationStatus }) => {
  const record = useRecordContext();

  const submitUpdateApplicationStatus = ({ screener_account_id, scheduled_time }: any) => {
    updateApplicationStatus({
      application_status: PhoneScreenScheduledStatus,
      screener_account_id,
      scheduled_time,
      professional_id: record?.id,
      reason: 'application',
      screening_type: 'phone',
    });
  };

  return (
    <Dialog open={open} onClose={closeDialog}>
      <DialogTitle>Schedule Phone Screening</DialogTitle>
      <SimpleForm
        onSubmit={submitUpdateApplicationStatus}
        toolbar={<SchedulePhoneScreenToolBar closeDialog={closeDialog} />}
      >
        <AdministratorInput
          source="screener_account_id"
          label="Screening Recruiter"
          filter={{
            permission_group_roles: [ENUMS.PermissionGroup.role.support_agent],
          }}
          emptyText="Clear"
          fullWidth
          optionValue="account.id"
        />
        <DateTimeInput label="Phone Screen Date And Time" source="scheduled_time" fullWidth />
      </SimpleForm>
    </Dialog>
  );
};

export default PhoneScreenScheduledItem;
